import { theme } from "@chakra-ui/core";

export const customTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    brand: {
      50: '#e1ffe2',
      100: '#b4fcb9',
      200: '#86f78e',
      300: '#57f562',
      400: '#2bf237',
      500: '#15d81e',
      600: '#0aa815',
      700: '#04780d',
      800: '#004805',
      900: '#001a00',
    }
  }
};


